module.exports = __webpack_public_path__ + "img/Jiesuan-banner.64ba3cfc.jpg";